// src/index.tsx

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { ThemeProvider } from './context/ThemeContext'
import { AuthProvider } from './context/AuthContext'
import App from './App'
import './index.css'

/*
 * Ordre des providers :
 * BrowserRouter  → active React Router dans toute l'app
 * ThemeProvider  → injecte le contexte dark/light + applique la classe sur <html>
 *
 * ⚠️ ThemeProvider DOIT être à l'intérieur de BrowserRouter
 *    (sinon useNavigate dans des guards futurs ne fonctionnerait pas),
 *    mais EN DEHORS de App pour que le thème soit disponible
 *    dès le premier render, avant tout paint.
 */
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
)